import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  DocumentPurchaseLiteModel,
  DocumentPurchaseModel,
  getDocumentPurchaseInput,
  getDocumentPurchasesInput,
} from './model';

export function useGetDocumentPurchases(
  input?: getDocumentPurchasesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<DocumentPurchaseLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<DocumentPurchaseLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['document-purchases', input?.params],
      () =>
        QueryFetchFunction({
          url: 'document-purchases',
          params: input?.params,
        }),
      options,
    ),
    DocumentPurchaseLiteModel,
  );
}

export function useGetDocumentPurchase(
  input?: getDocumentPurchaseInput,
  options?: UseQueryOptions<ApiResult<DocumentPurchaseModel>, ApiError>,
): UseQueryResult<ApiResult<DocumentPurchaseModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['document-purchases', input?.id],
      () =>
        QueryFetchFunction({
          url: `document-purchases/${input?.id}`,
        }),
      options,
    ),
    DocumentPurchaseModel,
  );
}

export function getDocumentPurchasesKey(input?: getDocumentPurchasesInput) {
  return ['document-purchases', input?.params];
}

export function getDocumentPurchaseKey(input?: getDocumentPurchaseInput) {
  return ['document-purchases', input?.id];
}
